"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxBatchedActions = require("redux-batched-actions");

var _requests = require("../libs/utils/requests");

var _GameActionTypes = require("../constants/action-types/GameActionTypes");

var ActionTypes = _interopRequireWildcard(_GameActionTypes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
} //TODO: this should maybe be done on the actions


var saveStateOnActions = [ActionTypes.ADD_PLAYER, ActionTypes.CONNECT_PLAYER, ActionTypes.INVITE_PLAYER, ActionTypes.DISCONNECT_PLAYER, ActionTypes.SET_GAME_STATE, ActionTypes.SET_PLAYER_STATE];

exports.default = function (roomId, config, token) {
  return function (store) {
    return function (next) {
      return function (action) {
        //Skip certain actions
        if (action.meta && action.meta.skipPersist === true || action.meta && action.meta.remoteRequest === true || action.type === _reduxBatchedActions.BATCH || typeof action === "function") {
          return next(action);
        }

        var timestampedAction = Object.assign({}, action, {
          meta: Object.assign({}, {
            timestamp: new Date()
          }, action.meta)
        }); // SAVE ACTION

        (0, _requests.sendRequest)({
          destination: config.serviceUrls.api.server + "/actions",
          options: {
            method: "POST",
            credentials: "include",
            body: JSON.stringify({
              action: timestampedAction,
              roomId: roomId
            }),
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token
            }
          }
        }).catch(function (err) {
          return console.error(err);
        }); // calling this before saving the state means saving state will be done after the action is reduced

        var result = next(action); // SAVE STATE

        if (saveStateOnActions.includes(action.type)) {
          (0, _requests.sendRequest)({
            destination: config.serviceUrls.api.serverRooms + "/" + roomId + "/state",
            options: {
              method: "PATCH",
              credentials: "include",
              body: JSON.stringify({
                state: store.getState()
              }),
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
              }
            }
          }).catch(function (err) {
            return console.error(err);
          });
        }

        return result;
      };
    };
  };
};